import axios from 'axios'
import store from '../store'
import { getToken, setToken, getTenantCode } from '@/utils/auth'
import { isSuccess } from '@/utils/util'
import { refreshToken } from '@/api/admin/login'
import { Message,MessageBox } from 'element-ui'
import errorCode from '@/const/errorCode'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
const whiteList = ['/auth/authentication/removeToken']// 白名单

// 超时时间
const instance = axios.create({
  // baseURL: baseURL,
  timeout: 60000,
  withCredentials: true
})

// 跨域请求，允许保存cookie
NProgress.configure({ showSpinner: false })// NProgress Configuration

// 是否正在刷新token标记
export let isRelogin = { show: false };
// refresh 次数阈值
let refreshCnt = 0
// 缓存所有请求(重试队列、每一项都是待执行的函数)
let requests = []

// 封装刷新token的方法
// function doRefreshToken(config) {
//   async function refresh() {
//     const token = getToken()
//     if (!isRefreshing) {
//       isRefreshing = true
//       refreshCnt++
//       if (refreshCnt > 3) {
//         Message({ message: 'token 刷新次数过多，请重新登录！', type: 'error' })
//         return
//       }
//       try {
//         refreshToken(token).then(response => {
//           setToken(response.data.result.token)
//           store.commit('SET_TOKEN', response.data.result.token)
//           requests.forEach((cb) => cb())
//           requests = []
//         }).catch(err => {
//           console.log(err, 'error')
//         })
//       } catch (error) {
//         Message({ message: 'token 刷新失败，请重新登录！', type: 'error' })
//         // 这里执行需重新登录的相关操作
//       } finally {
//         isRefreshing = false
//       }
//     }
//   }

//   refresh()

//   return new Promise((resolve) => {
//     requests.push((_) => {
//       config.headers['Authorization'] = getToken()
//       resolve(instance(config))
//     })
//   })
// }



function doRefreshToken(config) {
  if (!isRelogin.show) {
    isRelogin.show = true;
    MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
      isRelogin.show = false;
      store.dispatch('LogOut').then(() => {
        location.href = '/';
      })
  }).catch(() => {
    isRelogin.show = false;
  });
}
return Promise.reject('无效的会话，或者会话已过期，请重新登录。')


}
// HTTP request拦截
instance.interceptors.request.use(config => {
  NProgress.start() // start progress bar

  // const isToken = (config.headers || {}).isToken === false
  // // 是否需要防止数据重复提交
  // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (store.getters.token && whiteList.indexOf(config.url) === -1) {
    const authorization = config.headers['Authorization']
    if (authorization === undefined || authorization.indexOf('Basic') === -1) {
      // config.headers['Authorization'] = getToken() // 让每个请求携带token
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改

    }

    // if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    //   const requestObj = {
    //     url: config.url,
    //     data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
    //     time: new Date().getTime()
    //   }
    //   const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    //   const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    //   if (requestSize >= limitSize) {
    //     console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
    //     return config;
    //   }
    //   const sessionObj = cache.session.getJSON('sessionObj')
    //   if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
    //     cache.session.setJSON('sessionObj', requestObj)
    //   } else {
    //     const s_url = sessionObj.url;                  // 请求地址
    //     const s_data = sessionObj.data;                // 请求数据
    //     const s_time = sessionObj.time;                // 请求时间
    //     const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
    //     if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
    //       const message = '数据正在处理，请勿重复提交';
    //       console.warn(`[${s_url}]: ` + message)
    //       return Promise.reject(new Error(message))
    //     } else {
    //       cache.session.setJSON('sessionObj', requestObj)
    //     }
    //   }
    // }
  }
  // 增加租户编号请求头
  // const tenantCode = config.headers['Tenant-Code']
  // if (tenantCode === undefined) {
  //   config.headers['Tenant-Code'] = getTenantCode()
  // }
  return config
}, error => {
  return Promise.reject(error)
})

// HTTP response拦截
instance.interceptors.response.use(data => {
  NProgress.done()
  // 请求失败，弹出提示信息
  if (!isSuccess(data.data)) {
    // console.log("111", data.data)
    const code = data.data.code || 200;
    const msg = errorCode[code] || data.data.msg || errorCode['default']
    // token失效
    if (code === 401) {
      return doRefreshToken(data.config)
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 501) {
      // 对于501错误码，直接返回原始响应
      return data
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return data.data
    }

  }
  return data
}, error => {
  NProgress.done()
  if (error.response) {
    // const originalRequest = error.config
    // // 接口返回401并且已经重试过，自动刷新token
    // if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
    //   // 退出请求
    //   if (originalRequest.url.indexOf('removeToken') !== -1) {
    //     return
    //   }
    //   return refreshToken().then(response => {
    //     // 保存新的token
    //     setToken(response.data.token)
    //     store.commit('SET_TOKEN', response.data.token)
    //     // 带上新的token
    //     originalRequest.headers['Authorization'] = response.data.token
    //     // 重新请求
    //     return axios(originalRequest)
    //   }).catch(() => {
    //     // 刷新失败，执行退出
    //     store.dispatch('LogOut').then(() => location.reload())
    //   })
    // } else if (error.response.status === 423) {
    //   Message({ message: '演示环境不能操作', type: 'warning' })
    // } else if (error.response.status === 404) {
    //   // 跳转到404页面
    //   router.replace({
    //     path: '404',
    //     query: { redirect: router.currentRoute.fullPath }
    //   })
    // } else {
    // 其它错误则弹出提示
    //   const { code, msg } = error.response.data
    //   const errMsg = errorCode[String(code)] || msg || errorCode['default']
    //   Message({ message: errMsg, type: 'error' })
    //   // }
    // }
    // return Promise.reject(new Error(error))

    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
  }
    return Promise.reject(error)
  })

export default instance



// WEBPACK FOOTER //
// ./src/router/axios.js